import React, { useEffect, useState } from "react";
import validator from "@rjsf/validator-ajv8";
import Form from "@rjsf/mui";
import { db } from "../../indexDB/model";
import { useLocation } from "react-router-dom";
import FileFactoryOfflinePreview from "../customComponents/fileWidget/FileFactoryOfflinePreview";
import { Container, Typography } from "@mui/material";
import { QRCodeSVG } from 'qrcode.react';
import QrScanner from "./QrScanner";
import config from "../../config";

/**
 * Component for viewing datapoint details.
 *
 * @component
 * @example
 * // Example usage of ViewDatapoint component
 * <ViewDatapoint />
 *
 * @returns {JSX.Element} - ViewDatapoint component.
 */
const ViewDatapoint = () => {
  const { state } = useLocation();
  const datasetID = state?.datasetID || null;
  const draftId = state?.draftId || null;
  const formData = state?.formData || null;
  const id = state?.id || null;
  const [schema, setSchema] = useState(null);
  const files = state?.files;
  const status = state?.status;
  const currentDomain = process.env.REACT_APP_DOMAIN;
  const domainConfig = config[currentDomain];
  const QRCodeEnabled = domainConfig?.features?.QRCodeEnabled;

  /**
   * Fetches the schema for a given dataset ID and updates the state.
   *
   * @param {string} datasetID - ID of the dataset.
   * @returns {void}
   */
  async function getSchema(datasetID) {
    try {
      const dataset = await db.datasets
        .where("uuid")
        .equals(datasetID)
        .toArray();
      setSchema(dataset[0]?.schema);
    } catch (error) {
      console.error("Error fetching schema:", error);
    }
  }

  useEffect(() => {
    if (datasetID) {
      getSchema(datasetID);
    }
  }, [datasetID]);

  /**
   * Custom widget for FileWidget in the form.
   *
   * @param {Object} props - Widget props.
   * @returns {JSX.Element} - FileFactoryOfflinePreview widget.
   */
  const customWidgets = {
    FileWidget: (props) => (
      <FileFactoryOfflinePreview
        datapointID={id}
        files={files}
        {...props}
        status={status}
      />
    ),
    QrScannerWidget: (props) => (
      <QrScanner
        questionTitle={props.schema.title}
        optionalValue={props.value}
        onChange={props.onChange}
        disabled={true}
      />
    )
  };
  return (
    <div>
      {schema ? (
        <Container>
          {QRCodeEnabled && <Container 
            sx={{ 
              border: '2px solid black', 
              borderRadius: '8px', 
              padding: '8px', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center' 
            }}
          >
            <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>ID</Typography>
            <QRCodeSVG value={draftId} size={100} />
          </Container>}
          <Form
            schema={schema}
            validator={validator}
            formData={formData}
            widgets={customWidgets}
            uiSchema={schema?.ui_schema}
            disabled
          />
        </Container>
      ) : (
        <p>No schema available.</p>
      )}
    </div>
  );
};

export default ViewDatapoint;
